import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
`;

export const ItemsWrapper = styled.ol`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`;

export const ConsiderationsWrapper = styled.div`
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.purple3};
  background: ${({ theme }) => theme.colors.purple1};
`;

export const BoldWrapper = styled.span`
  font-weight: bold;
`;

export const TitleWrapper = styled.div`
  font-size: 14px;
  font-weight: 600;
`;

export const ConsiderationsList = styled.ul`
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 16px;
`;
